export const parseCoboAmount = (amount) => {
  if (amount == null) return '';
  if (typeof amount === 'object' && amount.$numberDecimal != null) return amount.$numberDecimal;
  if (typeof amount === 'number' || typeof amount === 'string') return amount;
  return String(amount);
};

export const mapCoboWithdrawalItem = (item = {}) => ({
  ...item,
  short_name: item.coin || item.short_name,
  currency: item.coin || item.currency,
  chain: item.chainId || item.chain,
  to_address: item.toAddress || item.to_address,
  transaction_hash: item.txHash || item.transaction_hash,
  amount: parseCoboAmount(item.amount),
  status: (item.status || 'Completed').toUpperCase(),
  updatedAt: item.completedAt || item.createdAt || item.updatedAt,
  createdAt: item.createdAt || item.updatedAt,
});
